import { publicClient, privateClient } from "../../configs/axiosConfig";

const serviceEndpoints = {
  getallNail: "v2/nails",
  getNailDetail: "v2/nails/:id",
  updateNailsService: "v2/nails/update-store",
  getallBeauty: "v2/beauty",
  getBeautyDetail: "v2/beauty/:id",
  updateBeautyService: "v2/beauty/update-store",

  getallService: "v2/services",
  getallServicePublic: `v2/services/getpublicnail?key=${process.env.REACT_APP_REMINDER_CRON_SECRET}`,
  getServiceDetail: "v2/services",

  createService: "v2/services/create",
  updateService: "v2/services/edit",
  deleteService: "v2/services/delete",

  //category
  createServiceCategory: "v2/services/category/create", // <-- adjust to match your backend route
  createServiceCategory: "v2/services/category/create",
  updateServiceCategory: "v2/services/category",
  getServiceCategory: "v2/services/getServiceCategory",
  deleteServiceCategory: "v2/services/category/delete",
};

const sericesApi = {
  //category section
  getServiceCategory: async ({ operator }) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.getServiceCategory,
        { operator }
      );
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Get operator failed");
    }
  },
  createServiceCategory: async (payload) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.createServiceCategory,
        payload
      );
      return { response };
    } catch (err) {
      console.log("err to create category");
      return { err };
    }
  },

  /** UPDATE category by id */
  updateServiceCategory: async ({ id, ...payload }) => {
    try {
      const response = await privateClient.patch(
        `${serviceEndpoints.updateServiceCategory}/${id}`,
        payload
      );
      return { response };
    } catch (err) {
      console.log("err to update category");
      return { err };
    }
  },
  /** Soft delete category: sets isDelete: "yes" on backend */
  deleteServiceCategory: async (id) => {
    try {
      const response = await privateClient.post(
        `${serviceEndpoints.deleteServiceCategory}/${id}`
      );
      return { response };
    } catch (err) {
      console.log("err to delete category");
      return { err };
    }
  },

  //create new services
  createService: async (payload) => {
    try {
      const response = await privateClient.post(
        serviceEndpoints.createService,
        payload
      );
      return response.data;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to create service"
      );
    }
  },
  // api/service/service.api.js
  updateService: async (id, data) => {
    try {
      const response = await privateClient.put(
        `${serviceEndpoints.updateService}/${id}`,
        data
      );
      return { success: true, service: response.data.service };
    } catch (err) {
      return { success: false, message: err.message };
    }
  },
  deleteService: async (id) => {
    try {
      const response = await privateClient.post(
        `${serviceEndpoints.deleteService}/${id}`
      );
      return { response };
    } catch (err) {
      console.log("err to delete service");
      return { err };
    }
  },
  getServiceDetail: async ({ id }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getServiceDetail}/${id}`
      );
      // response.data is the actual payload
      return response.data.serviceDetail; // ✅ return clean object
    } catch (err) {
      console.error("Error in getServiceDetail:", err);
      throw err;
    }
  },

  //all services
  getallServices: async ({ operatorId }) => {
    try {
      const response = await privateClient.get(
        `${serviceEndpoints.getallService}?operatorId=${operatorId}`
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },
  getallServicePublic: async () => {
    try {
      const response = await publicClient.get(
        serviceEndpoints.getallServicePublic
      );

      return { response };
    } catch (err) {
      console.log("err to get all nail");
      return { err };
    }
  },

  // // ----- old section --------------
  // getallNail: async ({ operatorId }) => {
  //   try {
  //     const response = await privateClient.get(
  //       `${serviceEndpoints.getallNail}?operatorId=${operatorId}`
  //     );

  //     return { response };
  //   } catch (err) {
  //     console.log("err to get all nail");
  //     return { err };
  //   }
  // },
  // getNailDetail: async ({ nailId }) => {
  //   try {
  //     const response = await privateClient.get(serviceEndpoints.getNailDetail, {
  //       nailId,
  //     });

  //     return { response };
  //   } catch (err) {
  //     console.log("err to get all nail");
  //     return { err };
  //   }
  // },
  // updateNailsService: async (payload) => {
  //   try {
  //     const response = await privateClient.patch(
  //       serviceEndpoints.updateNailsService,
  //       payload
  //     );
  //     return { response };
  //   } catch (err) {
  //     console.error("Failed to update service stores", err);
  //     return { err };
  //   }
  // },
  // getallBeauty: async ({ operatorId }) => {
  //   try {
  //     const response = await privateClient.get(
  //       `${serviceEndpoints.getallBeauty}?operatorId=${operatorId}`
  //     );

  //     return { response };
  //   } catch (err) {
  //     console.log("err to get all nail");
  //     return { err };
  //   }
  // },
  // getBeautyDetail: async ({ beatyId }) => {
  //   try {
  //     const response = await privateClient.get(
  //       serviceEndpoints.getBeautyDetail,
  //       {
  //         beatyId,
  //       }
  //     );

  //     return { response };
  //   } catch (err) {
  //     console.log("err to get all nail");
  //     return { err };
  //   }
  // },
  // updateBeautyService: async (payload) => {
  //   try {
  //     const response = await privateClient.patch(
  //       serviceEndpoints.updateBeautyService,
  //       payload
  //     );
  //     return { response };
  //   } catch (err) {
  //     console.error("Failed to update service stores", err);
  //     return { err };
  //   }
  // },
};

export default sericesApi;
